import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  CONFIGURATIONS,
  OFFICES,
  SOCIETIES,
  ORGANIZATIONAL_UNITS,
  ATTRIBUTES,
  COUNTERS,
  USERS_OPERATIONS_CONFIGURATIONS,
  REQUEST_STATE,
  OU_ENRICHMENTS,
  ROLES,
  SELECTED_ROLE,
  BUTTONS,
  FIELD_VISIBILITY,
} = STATE_IDENTIFIER;

export default {
  [CONFIGURATIONS]: {
    [OFFICES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [SOCIETIES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [ORGANIZATIONAL_UNITS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [ATTRIBUTES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [COUNTERS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [CONFIGURATIONS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [OU_ENRICHMENTS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [USERS_OPERATIONS_CONFIGURATIONS]: {
    [ROLES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
    [SELECTED_ROLE]: [],
    [BUTTONS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [FIELD_VISIBILITY]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
